import React, { useEffect } from "react";
import CustomDropdown from "../../common/CustomDropdown";

const Venue = ({
  handleSaveEvent,
  countryList = [],
  handleCountrydata,
  handleFileChange,
  uploadedVenuePhoto,
  venuePhoto,
  venueName,
  setVenueName,
  city,
  setCity,
  country,
  state,
  setState,
  handleStatedata,
  stateList,
  venueAddress,
  setVenueAddress,
  venuePincode,
  setVenuePincode,
  venueGoogleMapLink,
  setVenueGoogleMapLink,
  isDetailedAddress,
  venueImageError,
  handleOpenDetailedAddress,
  errors = {},           // ← NEW
  setErrors,             // ← NEW
}) => {
  const handleImageUpload = () => {
    document.getElementById("imageUploadInput").click();
  };

  // Fetch states when country changes
  useEffect(() => {
    if (country && !stateList.length) {
      handleCountrydata(country);
    }
  }, [country, stateList, handleCountrydata]);

  // Validate on every change
  const validateField = (field, value) => {
    let error = "";
    if (!value || value.toString().trim() === "") {
      switch (field) {
        case "venueName":
          error = "Venue name is required";
          break;
        case "country":
          error = "Country is required";
          break;
        case "state":
          error = "State is required";
          break;
        default:
          break;
      }
    }
    setErrors((prev) => ({ ...prev, [field]: error }));
  };

  // Clear error when user starts typing/selecting
  const clearError = (field) => {
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  // Validate all mandatory fields before save
  const validateAndSave = () => {
    const newErrors = {};

    if (!venueName?.trim()) newErrors.venueName = "Venue name is required";
    if (!country) newErrors.country = "Country is required";
    if (!state) newErrors.state = "State is required";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }

    handleSaveEvent(); // Only call if valid
  };

  return (
    <div className="card shadow-sm">
      {/* <div className="card-header setting_card_heading setting_card_heading_size">
        <h5>Venue</h5>
        <p>
          Specify the location of your event, including the venue name, city,
          country, and any other relevant details.
        </p>
      </div> */}
      <div className="card-body border-0">
        {/* Venue Image */}
        <div className="row">
          <div className="col-md-12">
            <label className="fw-bold">Venue Image</label>
            <div className="row align-center gap-15 pad_left_15">
              <div>
                <div className="pos_relative">
                  <div className="pos_re">
                    <img
                      src={uploadedVenuePhoto || "https://placehold.co/700x400"}
                      width="100"
                      height="100"
                      className="img-thumbnail width_profile_image"
                      alt="Uploaded"
                      onClick={handleImageUpload}
                      style={{
                        cursor: "pointer",
                        objectFit: "cover",
                        border: "2px solid #ddd",
                        borderRadius: "4px",
                      }}
                    />
                    <i
                      onClick={handleImageUpload}
                      className="fa fa-pencil upload_image_edit_icon"
                      style={{ cursor: "pointer" }}
                    />
                    <input
                      type="file"
                      id="imageUploadInput"
                      style={{ display: "none" }}
                      accept="image/*"
                      onChange={handleFileChange("venuePhoto")}
                    />
                  </div>
                </div>
              </div>
              <div>
                <p>
                  JPG, PNG, SVG, GIF. Recommended: 150 × 100 or 100 × 150 px.
                </p>
              </div>
            </div>
            {venueImageError && (
              <p className="text-danger mt-1">{venueImageError}</p>
            )}
          </div>
        </div>

        {/* Venue Name */}
        <div className="form-group">
          <label>
            Venue Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className={`form-control ${errors.venueName ? "is-invalid" : ""}`}
            value={venueName || ""}
            onChange={(e) => {
              setVenueName(e.target.value);
              clearError("venueName");
            }}
            onBlur={() => validateField("venueName", venueName)}
            placeholder="Enter venue name"
          />
          {errors.venueName && (
            <div className="text-danger">{errors.venueName}</div>
          )}
        </div>

        {/* City and Country */}
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>City</label>
              <input
                type="text"
                className="form-control"
                value={city || ""}
                onChange={(e) => setCity(e.target.value)}
                placeholder="Enter city name"
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>
                Country <span className="text-danger">*</span>
              </label>
              <CustomDropdown
                dropdownData={countryList}
                dropdownValue={country}
                setDropdownValue={(value) => {
                  handleCountrydata(value);
                  clearError("country");
                }}
                name="country name"
                fieldName="country"
                eventType={"Update"}
                className={errors.country ? "is-invalid" : ""}
              />
              {errors.country && (
                <div className="text-danger">{errors.country}</div>
              )}
            </div>
          </div>
        </div>

        {/* Detailed Address */}
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>Street Address</label>
              <input
                type="text"
                className="form-control"
                placeholder="Street Address"
                value={venueAddress || ""}
                onChange={(e) => setVenueAddress(e.target.value)}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>
                State <span className="text-danger">*</span>
              </label>
              <CustomDropdown
                dropdownData={stateList}
                dropdownValue={state}
                setDropdownValue={(value) => {
                  handleStatedata(value);
                  clearError("state");
                }}
                name="state name"
                fieldName="state"
                eventType={"Update"}
                className={errors.state ? "is-invalid" : ""}
              />
              {errors.state && <div className="text-danger">{errors.state}</div>}
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>Zip Code</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter zip"
                value={venuePincode || ""}
                onChange={(e) => setVenuePincode(e.target.value)}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>Google Map Link</label>
              <input
                type="text"
                className="form-control"
                placeholder="Google map link"
                value={venueGoogleMapLink || ""}
                onChange={(e) => setVenueGoogleMapLink(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* Save Button */}
        <div className="row mt-3">
          <div className="col-md-3">
            <button
              className="btn btn-outline-primary"
              onClick={validateAndSave}
              disabled={errors.venueName || errors.country || errors.state}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Venue;